import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const fundValuationFrequencySelector = ({ fundValuationFrequency }: ReducerState) => fundValuationFrequency;
export const fundValuationFrequencyLoadingSelector = createSelector(
  fundValuationFrequencySelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
